module.exports = __webpack_public_path__ + "bin/c2d3f4e113db872785c6d8d679b4a052.svg";